<div class="container py-5">
  <div class="headerPage">
    <h1 class="main-title" [style.color]="labelColor">Ingressos</h1>
    <app-button
      id="back-desktop"
      [onlyIcon]="true"
      [isIcon]="true"
      [left]="true"
      [iconName]="'bi bi-arrow-left'"
      [buttonOptions]="buttonBackOptions"
      (buttonClick)="back()"
    >
    </app-button>
  </div>
  @if (showDiv) {
  <div class="d-grid d-md-flex flex-wrap">
    @for (ticket of ingressosCheckIn; track $index) {
    <div class="col-12 col-lg-6 col-xl-4">
      <app-ticket-card
        [ticket]="ticket"
        [memberPlan]="memberPlan"
        [memberData]="memberData"
        [hasCheckinBtn]="hasCheckinBtn"
        (btnCheckInAction)="openCheckInModal($event)"
      ></app-ticket-card>
    </div>
    } @if (ingressosCheckIn.length === 0) {
    <b>
      Não existem jogos para realização de check-in ou compra de ingressos.
    </b>
    }
  </div>
  }
</div>

<app-form-modal
  [modalId]="modalId"
  [modalTitle]="'Realizar Check-in'"
  [showCloseBtn]="false"
  [ticketData]="ingressosCheckIn"
  [checkinsHistory]="checkinsHistory"
  [limitCheckin]="limitCheckin"
  [checkinSelected]="checkinSelected"
  [selectInputOptions]="selectInputOptionsModal"
  [selectControl]="selectControlModal"
  [isSenior]="isSenior"
  [isAtLeast12]="isAtLeast12"
  [memberDependents]="memberDependents"
  (onModalConfirm)="onModalFormConfirm($event)">
</app-form-modal>

<app-confirm-modal
  [modalId]="'modalConfirm'"
  [link]="linkModalConfirm">
</app-confirm-modal>

<app-modal-change-checkin
  [modalId]="'modalChangeCheckin'"
  [pendentTicket]="pendentTicket">
</app-modal-change-checkin>

<app-choose-payment-modal
  [modalId]="'modalChoosePayment'"
  [modalTitle]="'Escolha a forma de pagamento'"
  [size]="'modal-md'"
  [modalData]="paymentModalData"
  (confirmActionChange)="onModalConfirm($event)">
</app-choose-payment-modal>
